export default __webpack_public_path__ + "static/media/NL.ead97e77.svg";